module.exports = __webpack_public_path__ + "img/fi-rr-align-left.c1e4a92e.svg";